'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENDPOINT_URL = '/upgrade-catalog/v1/purchase-orders/offer-builder';

var offerBuilderApi = {
  put: function put(_ref) {
    var offerPayload = _ref.offerPayload,
        currencyCode = _ref.currencyCode;

    return _apiClient2.default.put(ENDPOINT_URL, {
      query: {
        'currency-code': currencyCode
      },
      data: offerPayload
    });
  }
};

exports.default = offerBuilderApi;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/api/offerBuilderApi.js
// module id = 585
// module chunks = 3 4 5